/*@flow*/
import hasOwn from 'lib/hasOwn';

let registry: {|
  Any: $FlowFixMe,
  Array: $FlowFixMe,
  Boolean: $FlowFixMe,
  Date: $FlowFixMe,
  Error: $FlowFixMe,
  Function: $FlowFixMe,
  Nil: $FlowFixMe,
  Number: $FlowFixMe,
  Object: $FlowFixMe,
  RegExp: $FlowFixMe,
  String: $FlowFixMe,
  Type: $FlowFixMe,
|} = {
  Any: require('./Any').default,
  Array: require('./Array').default,
  Boolean: require('./Boolean').default,
  Date: require('./Date').default,
  Error: require('./Error').default,
  Function: require('./Function').default,
  Nil: require('./Nil').default,
  Number: require('./Number').default,
  Object: require('./Object').default,
  RegExp: require('./RegExp').default,
  String: require('./String').default,
  Type: require('./Type').default,
};
type Callable = any => any;

export const add = (name: string, type: Callable): {|
  Any: $FlowFixMe,
  Array: $FlowFixMe,
  Boolean: $FlowFixMe,
  Date: $FlowFixMe,
  Error: $FlowFixMe,
  Function: $FlowFixMe,
  Nil: $FlowFixMe,
  Number: $FlowFixMe,
  Object: $FlowFixMe,
  RegExp: $FlowFixMe,
  String: $FlowFixMe,
  Type: $FlowFixMe,
|} => (registry = { ...registry, [name]: type });

export const remove = (name: string): {|
  Any: $FlowFixMe,
  Array: $FlowFixMe,
  Boolean: $FlowFixMe,
  Date: $FlowFixMe,
  Error: $FlowFixMe,
  Function: $FlowFixMe,
  Nil: $FlowFixMe,
  Number: $FlowFixMe,
  Object: $FlowFixMe,
  RegExp: $FlowFixMe,
  String: $FlowFixMe,
  Type: $FlowFixMe,
|} => {
  delete registry[name];
  return registry;
};

export const get = (name: string): any => registry[name];

export const has = (name: string): any => hasOwn.call(registry, name);

export default registry;
